module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("TITLE PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("COPYRIGHT NOTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#foreword"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("BY")]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chris Claremont")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PROFESSOR INCOGNITO APOLOGIZES: AN ITEMIZED LIST")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Austin Grossman")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("FATHER OF THE GROOM")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Harry Turtledove")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("LAUGHTER AT THE ACADEMY")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Seanan McGuire")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("LETTER TO THE EDITOR")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("David D. Levine")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("INSTEAD OF A LOVING HEART")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jeremiah Tolbert")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE EXECUTOR")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daniel H. Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE ANGEL OF DEATH HAS A BUSINESS PLAN")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Heather Lindsley")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("HOMO PERFECTUS")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("David Farland")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ANCIENT EQUATIONS")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("L. A. Banks")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("RURAL SINGULARITY")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Alan Dean Foster")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CAPTAIN JUSTICE SAVES THE DAY")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Genevieve Valentine")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE MAD SCIENTIST’S DAUGHTER")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Theodora Goss")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE SPACE BETWEEN")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Diana Gabaldon")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("HARRY AND MARLOWE MEET THE FOUNDER OF THE AETHERIAN REVOLUTION")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Carrie Vaughn")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("BLOOD & STARDUST")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Laird Barron")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("A MORE PERFECT UNION")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("L. E. Modesitt, Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ROCKS FALL")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Naomi Novik")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("WE INTERRUPT THIS BROADCAST")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mary Robinette Kowal")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE LAST DIGNITY OF MAN")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Marjorie M. Liu")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE PITTSBURGH TECHNOLOGY")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Jeffrey Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("MOFONGO KNOWS")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Grady Hendrix")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("THE FOOD TASTER’S BOY")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Ben H. Winters")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adcard",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ALSO EDITED BY JOHN JOSEPH ADAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor#about",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ABOUT THE EDITOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightacknowledgments#crtack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("COPYRIGHT ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0